import { DatePipe } from '@angular/common';
import { Component, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { FormSessionCanDeactivate } from '../../shared';
import { User } from '../../shared/models';
import { PatientService, UserService } from '../../shared/services';
import { Subscription } from 'rxjs';


@Component({
	selector: 'app-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.css']
})
export class ProfileComponent extends FormSessionCanDeactivate {
	DatepickerConfig: Partial<BsDatepickerConfig>
	public timealert = environment.timelimit;
	imgMaxSize = environment.imagefileSize;
	pro: any;
	currentUser: User;
	setlength: any;
	maxlen: any;
	setlength1: any;
	maxlen1: any;
	question: any = [];
	userinfo: any;
	public datenew = new Date("01/01/1800");
	userlist: any;
	setmask: any;
	setmask1: any;
	maxdate: boolean;
	mindate: boolean;
	public selectques = [];
	public selectques1 = [];
	public selectques2 = [];
	imagearr: any;
	secQuestionOne: any = '';
	secQuestionThree: any = '';
	secQuestionTwo: any = '';
	secQusAnswerOne: any
	secQusAnswerThree: any
	secQusAnswerTwo: any
	hospitalid: any;
	showinvaild1: boolean;
	emailvaild: boolean = false;
	showloader: boolean = false;
	passval: boolean = false;
	passval1: boolean = false;
	passval2: boolean = false;
	passval3: boolean = false;
	passval4: boolean = false;
	passkey: boolean = false;
	passkey1: boolean = false;
	passkey2: boolean = false;
	passkey3: boolean = false;
	passkey4: boolean = false;
	passlast: boolean = false;
	passlast1: boolean = false;
	passlast2: boolean = false;
	passlast3: boolean = false;
	passlast4: boolean = false;
	myInputVariable: any;
	dataimg: any;
	codes: any;
	alterNo: any;
	res: any;
	resp: any;
	respass: any;
	resepon: any;
	langSubscription: Subscription;
	outOfOfficeArr = [];
	outOfOfficeStatus: number = 1;
	outOfOfficeReason: any = "";
	outOfOfficeNotice: any = "";
	outOfOfficeerror = false;
	fromDate: any;
	toDate: any;
 firstSplitStartDate: string;
secondSplitEndDate: string;
	displayReason:string="";
	msgInfo="";
	msgContext="";	
	public bobMaxDate = new Date();
	public patientUrl = './assets/img/users/addusericon.png'
	public defaultUl = './assets/img/users/addusericon.png'
	public dateformat = environment.dateFormat;
	public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
	public Patpro: any = {
		comType: '',
		otherPhoneType: 1
	};
	public Cprofile: any = {
		comType: '',
		otherPhoneType: 1
	};
	public cha: any = { oldPassword: '' };
	apiurl: any = environment.api_url;
	modalRef: BsModalRef;
	modalRef1: BsModalRef;
	prefLang: any;
	languageConfig = {
		"multiLanguageRequired" : false,
		"languages": []
	}
	temppassword: any;
	updateCheck: number = 0;
	firstTimeClick = true;
	dateError: boolean = false;
	constructor(
		public datepipe: DatePipe,
		private router: Router,
		private userService: UserService,
		private modalService: BsModalService,
		private patientservice: PatientService,
		private toast: ToastrService,
		private localeService: BsLocaleService,
		private datePipe: DatePipe
	) {
		super();
		//console.log("Patid", window.localStorage['patid'])
		if (window.localStorage['patid']) {
			window.localStorage.removeItem('patid')
		}

		//console.log("patientId", window.localStorage['patientId'])
		if (window.localStorage['patientId']) {
			window.localStorage.removeItem('patientId')
		}

		if (window.localStorage['superClientId']) {
			this.changepassword = false;
		}
		else {
			this.changepassword = true;
		}
		enGbLocale.invalidDate = '';
		enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
		enGbLocale.week.dow = 0;
		defineLocale('custom locale', enGbLocale);
		this.localeService.use('custom locale');
		this.prefLang = this.userService.defaultLang;
	}

	changepassword: boolean = false;
	imageURL: string = environment.cloudeImageURL;
	tempCode: any;
	ngOnInit() {

		this.userService.currentUser.subscribe(
			(userData) => {
				this.currentUser = userData;
				if (this.currentUser.item) {
					this.setmask = this.currentUser.item.phoneFormat.split('#').join('0').concat('0');
					this.setmask1 = this.currentUser.item.phoneFormat.split('#').join('0').concat('0');
					if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
						this.dateformat = environment.dateFormat;
					} else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
						this.dateformat = 'DD/MM/YYYY'
					}
					this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
					if (this.currentUser.item.hostModel == "CLOUD")
						this.imageURL = environment.cloudeImageURL;
					else
						this.imageURL = environment.vmImageURL;
				}
			}
		);



		this.hospitalid = this.currentUser.item.userAccountKey;
		this.fetchOutOfOfficeStatus();
	  
		this.getselect();
		this.getalter();
		this.bindCNStatus();
		this.userService
			.getProfile(this.currentUser.item.userId)
			.subscribe(
				res => {
					let data = res.aaData;
					for (var i = 0; i < data.length; i++) {
						this.Patpro = data[i];

						if (this.Patpro.comType == 'NONE') {
							this.Patpro.notificationfrequency = 'None'
							this.Patpro.realtimemessage = false
							this.Patpro.realtimealert = false
						}
						if (this.Patpro.imagePath.search("default_") == -1)
							this.dataimg = this.imageURL + this.Patpro.imagePath;
						else
							this.dataimg = this.defaultUl

						this.temMail = data[i].email;
						this.temPhone = data[i].phone
						this.getPreferredLanguage(this.temMail);
						/* 	////console.log("mail",this.temMail)
							this.testmail = data[i].email.split('@')[1];
							////console.log("mail",this.testmail) */
						if (this.Patpro.phone)
							this.Patpro.code = this.Patpro.teleCode + ',' + this.Patpro.teleCountryCode
						else {
							if (this.currentUser.item.language != 'en_uk') {
								this.Patpro.code = '+1,USA'
							} else if (this.currentUser.item.language == 'en_uk') {
								this.Patpro.code = '+44,UK'
							}
							if (this.currentUser.item.clientTeleCode)
								this.Patpro.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
						}
						if (this.Patpro.phoneOther) {
							this.phoneOthervalue = true
							this.Patpro.codeOther = this.Patpro.teleCodeOther + ',' + this.Patpro.teleCountryCodeOther
						}
						else {
							this.phoneOthervalue = false
							if (this.currentUser.item.language != 'en_uk') {
								this.Patpro.codeOther = '+1,USA'
							} else if (this.currentUser.item.language == 'en_uk') {
								this.Patpro.codeOther = '+44,UK'
							}
							if (this.currentUser.item.clientTeleCode)
								this.Patpro.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
						}
						if (this.Patpro.comType == 'SMS') {
							this.Patpro.comType = 'TEXT'
						} else if (!this.Patpro.comType) {
							this.Patpro.comType = 'NONE'
						}
						this.Patpro.otherPhoneType = 1
						this.checkphonelength(this.Patpro.code);
						//this.checkphonlength(this.Patpro.code, '', '')
						this.checkphonelength1(this.Patpro.codeOther);
						this.checkphonlength1(this.Patpro.codeOther, '')
						if (this.Patpro.phone == " ") {
							this.Patpro.phone = ""
						}

						if (this.Patpro.phoneOther == " ") {
							this.Patpro.phoneOther = ""
						}
						this.getpassword()
						this.Cprofile = JSON.parse(JSON.stringify(this.Patpro))
						this.tempCode = this.Patpro.code
					}
					//////console.log(data);
				}

			);
		// Security Questions
			this.getSecurityQuestions();
	



		if (this.currentUser.item)
			this.getmenu();

		this.langSubscription = this.userService.langFileSubject.subscribe((data)=> {
			if(data == true && this.updateCheck == 1) {
				this.updateCheck = 0 //reset
				this.respass = this.userService.translateText('patient_portal.display_messages.profile_updated.success');
				this.userService.logAudit("updateCCProfile", 0).subscribe(data => { })
				this.modalRef = this.modalService.show(this.temppassword, { class: 'modal-sm', backdrop: 'static' });
				this.movable()
				if (!this.isProfileUpdate)
					this.userService.setProfileAuth();
				this.userService.languageFileLoadStatus(false);
			}
		});
	}

	//Fetch Out of office status for load OOO Section
	fetchOutOfOfficeStatus() {
		this.userService.fetchUserStatus(this.currentUser.item.userAccountId)
		.subscribe(res => {
			if(res?.outOfOfficeMasterId){
				this.outOfOfficeStatus = res.outOfOfficeMasterId;
				this.outOfOfficeReason = res.outOfOfficeReason || '';

				if(res.outOfOfficeFromDate&& res.outOfOfficeToDate)
				{
					this.fromDate = new Date(res.outOfOfficeFromDate.split(' ')[0] || ''); 
					this.toDate   = new Date(res.outOfOfficeToDate.split(' ')[0]|| '');
				}
				this.displayReason = res;
				this.msgInfo = res.msgInfoTemplate;
				this.msgContext = res.msgContextTemplate;
				let firstSplit = this.msgContext.split('<<fromDate>>');
				let secondSplit = firstSplit[1].split('<<toDate>>');
				this.firstSplitStartDate = firstSplit[0];
				this.secondSplitEndDate = secondSplit[0];
			}
		});
	}
	validateDates() {
		if (this.fromDate && this.toDate) {
		  const from = new Date(this.fromDate);
		  const to = new Date(this.toDate);
	  
		  from.setHours(0,0,0,0);
		  to.setHours(0,0,0,0);
	  
		  this.dateError = to < from;
		} else {
		  this.dateError = false;
		}
	}

	ngOnDestroy() {
		this.langSubscription?.unsubscribe();
	}

	getSecurityQuestions() {
		this.patientservice
		.getquestions()
		.subscribe(
			data => {
				////console.log(data);
				if (data) {

					this.question = data;
					this.getSecretQue();
				}
				else {
				}
			}
		);

	}

	//getpassword
	getpassword() {
		let self = this;
		self.patientservice.getPatientPassword(this.temMail, self.currentUser.item.userAccountId)
			.subscribe(data => {
				if (data.item.status == 'success') {
					self.userService.logAudit('getPassword', 0).subscribe(data => { })
					this.credentials = {
						'username': data.item.uname,
						'password': data.item.pwd
					}
				}
			})
	}




	menu: any;
	menustatus: any;
	getmenu() {
		this.userService.postuserinfoid('1', this.currentUser.item.userAccountId)
			.subscribe(
				data => {
					this.menu = data[1].menu;

					if (this.menu) {
						for (var i = 0; i < this.menu.length; i++) {
							if (this.menu[i].refName == 'PAT_TWOWAYMESSAGE') {
								this.menustatus = this.menu[i].status

							}
						}
					}
				})
	}

	checkcode(codecoun) {
		this.userService.phonebycountrycode(codecoun)
			.subscribe(
				data => {
					this.setlength = data.Length;
					this.maxlen = data.Length + this.currentUser.item.length;
					if (data.Length == 11) {
						this.setmask = this.currentUser.item.phoneFormat.split('#').join('0').concat('0')
					} else {
						this.setmask = this.currentUser.item.phoneFormat.split('#').join('0')
					}
				}
			);
	}
	checkcode1(codecoun) {
		this.userService.phonebycountrycode(codecoun)
			.subscribe(
				data => {
					this.setlength1 = data.Length;
					this.maxlen1 = data.Length + this.currentUser.item.length;
					if (data.Length == 11) {
						this.setmask1 = this.currentUser.item.phoneFormat.split('#').join('0').concat('0')
					} else {
						this.setmask1 = this.currentUser.item.phoneFormat.split('#').join('0')
					}
				}
			);
	}
	i: number = 0;
	checkphonelength(e) {
		if (this.i != 0)
			this.Patpro.phone = "";

		this.i++
		let telecode = e.split(',')
		let codecoun = telecode[1]
		this.checkcode(codecoun)
	}
	j: number = 0;
	checkphonelength1(e) {
		if (this.j != 0)
			this.Patpro.phoneOther = "";

		this.j++
		let telecode = e.split(',')
		let codecoun = telecode[1]
		this.checkcode1(codecoun)
	}

	emailChange() {
		////console.log("in")
		let self = this;
		if (this.temMail == this.Patpro.email) {
			return;
		} else {
			if (self.Patpro.email && self.Patpro.phone) {
				self.Patpro.comType = "BOTH"
				self.required = true
			}
			else if (!self.Patpro.email) {
				self.Patpro.comType = "TEXT"
				self.required = false
			}
			else if (!self.Patpro.phone) {
				self.Patpro.comType = "EMAIL"
				self.required = true
			} else {
				self.Patpro.comType = "NONE"
			}
		}
		////console.log("in",this.Patpro.comType)
	}
	required: boolean;
	temPhone: any = '';
	temMail: any;
	phoneChange() {
		////console.log("in")
		let self = this;
		if (this.temPhone == this.Patpro.phone) {
			return;
		} else {
			if (self.Patpro.email && self.Patpro.phone) {
				self.Patpro.comType = "BOTH"
				self.required = true
			}
			else if (!self.Patpro.email) {
				self.Patpro.comType = "TEXT"
				self.required = false
			}
			else if (!self.Patpro.phone) {
				self.Patpro.comType = "EMAIL"
				self.required = true
			} else {
				self.Patpro.comType = "NONE"
			}
		}
		////console.log("in",this.Patpro.comType)
	}

	getvalue(event) {
		////console.log("value",event)
		if (event == 'EMAIL') {
			this.Patpro.comType = 'EMAIL'
		}
		//   else if(event == 'TEXT'){
		// 	this.Patpro.comType = 'TEXT'
		//   }
		//   else if(event == 'BOTH' ){
		// 	this.Patpro.comType = 'BOTH'
		// 	}
		else if (event == 'NONE') {
			this.Patpro.comType = "NONE"
			this.Patpro.realtimemessage = false
			this.Patpro.realtimealert = false
		}
	}

	checkempty1(id) {
		let date
		if (id != 'Invalid Date')
			date = this.datepipe.transform(id, 'yyyy-MM-dd');
		let curentdate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
		if (id == '' || id == null || id == 'Invalid Date') {
			this.showinvaild1 = true;
			this.mindate = false;
			this.maxdate = false;
		} else if (id != '' && id != null && date <= "1800-01-01") {
			this.mindate = true;
			this.showinvaild1 = false;
			this.maxdate = false;
		} else if (id != '' && id != null && date > curentdate) {
			this.maxdate = true;
			this.showinvaild1 = false;
			this.mindate = false;
		} else {
			this.showinvaild1 = false;
			this.mindate = false;
			this.maxdate = false;
		}

	}

	showinvaild: boolean;
	checkempty(id) {
		////console.log(id)
		if (id == '' || id == null || id == 'Invalid Date') {
			this.showinvaild = true
		} else if (id != '' && id != null) {
			this.showinvaild = false
		}
	}


	// fileUpload(event) {
	// 	let reader = new FileReader();
	// 	reader.readAsDataURL(event.target.files[0]);
	// 	reader.onload = (events: any) => {
	// 		this.dataimg = events.currentTarget.result; 
	// 		this.imagearr = [{
	// 			filename: event.target.files[0].name,
	// 			filetype: event.target.files[0].type,
	// 			value: events.currentTarget.result.split(',')[1]
	// 		}];


	// 	}
	// }

	getPreferredLanguage(email) {
		const credential = {
			'userName': !email ? this.Patpro.teleCode.replace("+",'') + "-" + this.temPhone : email,
		}
		
		this.userService.getLanguageConfig(credential).subscribe(
		langConfigRes => {
			if(langConfigRes && langConfigRes.hasOwnProperty("multiLanguageRequired")) {
			this.languageConfig = langConfigRes;
			if(langConfigRes?.multiLanguageRequired) {
				this.prefLang = langConfigRes?.preferredlanguage;
				setTimeout(() => {
					const cnDropElement = document.getElementById("multilang") as HTMLSelectElement;
					if (cnDropElement) {
						cnDropElement.value = langConfigRes?.preferredlanguage;
					}
				}, 500);
			}
			}
		});
	}

	fileUpload(event) {
		let acceptFormat = ['image/png', 'image/x-png', 'image/jpeg', 'image/jpg']
		let reader = new FileReader();
		reader.readAsDataURL(event.target.files[0]);
		reader.onload = (events: any) => {
			if (!acceptFormat.includes(event.target.files[0].type)) {
				this.toast.error(this.userService.translateText('patient_portal.validations.file_not_allowed.error_label'), '', {
					timeOut: this.timealert
				})
				// this.myInputVariable.nativeElement.value = "";
				this.dataimg = this.defaultUl;
				return;
			}
			if (event.target.files[0].size > this.imgMaxSize) {
				this.toast.error(this.userService.translateText('patient_portal.validations.maximum_size_exceed.error_label'), '', {
					timeOut: this.timealert
				})
				// this.myInputVariable.nativeElement.value = "";
				this.dataimg = this.defaultUl;
				return;
			} else {
				this.dataimg = events.currentTarget.result;
				this.imagearr = [{
					filename: event.target.files[0].name,
					filetype: event.target.files[0].type,
					value: events.currentTarget.result.split(',')[1]
				}];
			}

		}
	}
	getselect() {
		let self = this;
		self.patientservice.getselcode(this.hospitalid)
			.subscribe(data => {
				self.codes = data

			})
	}
	getalter() {
		let self = this;
		self.patientservice.getAlterNo()
			.subscribe(data => {
				self.alterNo = data
				self.Patpro.otherPhoneType = 1
			})
	}

	show: boolean;
	toggleShow(event, id, inputid) {
		this.show = !this.show;

		if (this.show) {
			$(`#${id}`).removeClass('fa-eye')
			$(`#${id}`).addClass('fa-eye-slash')
			let input = $(`#${inputid}`);
			input.attr('type', 'text')
		}
		else {
			$(`#${id}`).removeClass('fa-eye-slash')
			$(`#${id}`).addClass('fa-eye')
			let input = $(`#${inputid}`);
			input.attr('type', 'password')

		}
	}

	// 	checkemail(){
	//     let self = this;
	//     if(self.temMail ==  self.Patpro.email){
	//       return;
	//     }
	//     self.patientservice.getPatientEmailExist(self.Patpro.email)
	//     .subscribe(data=>{
	//       if(data){
	//         self.Patpro.email=""
	//         self.toast.error("This email has already been registered",  '', {
	//           timeOut: this.timealert})
	//       }
	//      })

	//   }

	validateEmail(email) {

		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());

	}
	checkEmail(userdetails) {
		let self = this;
		////console.log(this.emailvaild)
		if (!this.emailvaild) {

			if (self.temMail.toLowerCase() == self.Patpro.email.toLowerCase()) {
				return;
			}
			let checkEmail = self.validateEmail(self.Patpro.email)
			if (checkEmail) {
				let data = {
					"oldEmail": self.temMail ? self.temMail : '',
					"newEmail": self.Patpro.email,
					"oldPhone": '',
					"newPhone": '',
					"addOrEdit": "edit",
					"updatingProfileRole": self.currentUser.item.userGroupId
				}
				self.patientservice.getUserExist(data, this.currentUser.item.userAccountKey)
					.subscribe(data => {
						////console.log(this.timealert)
						if (data.status == 'success') {
							if (data.popUpStatus) {
								this.userService.getuserdetails(self.Patpro.email)
									.subscribe(
										data => {
											if (data.firstName) {
												this.userinfo = data
												if (((!this.Patpro.firstName && !this.Patpro.lastName && !this.Patpro.email) || (data.firstName != this.Patpro.firstName) || (data.lastName != this.Patpro.lastName))) {
													this.modalRef1 = this.modalService.show(userdetails, {
														class: 'modal-md',
														backdrop: 'static'
													})
													this.movable();
												}
											}
										})
							}

						} else {
							self.Patpro.email = ""
							self.toast.error(this.userService.translateText('patient_portal.validations.email_already_exist.error_label'), '', {
								timeOut: this.timealert
							})
						}
					})
			} else {
				self.Patpro.email = ""
				self.toast.error(this.userService.translateText('patient_portal.validations.enter_a_valid_email.error_label'), '', {
					timeOut: this.timealert
				})

			}
		}
	}





	openModal(template: TemplateRef<any>) {
		this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
		this.movable()
	}



	saveprofile(p, temppassword) {
		if (this.temMail.toLowerCase() == this.Patpro.email.toLowerCase()) {
			this.savepro(p, temppassword)
		} else {
			this.patientservice.getPatientEmailExist(p.value.email.toLowerCase(), this.currentUser.item.userAccountKey)
				.subscribe(data => {
					////console.log(this.timealert)
					if (!data) {
						this.savepro(p, temppassword)
					}

				})
		}

	}


	isProfileUpdate: boolean = false
	credentials: any;
	profileChange($event) {
		if ($event) {
			this.isProfileUpdate = true

		}
	}
	checkPwd(pas) {
		if (pas.target.value) {
			this.patientservice.chkPass(pas.target.value)
				.subscribe(
					data => {
						if (data[0].status == 'failure') {
							this.cha.newPassword = '';
							this.cha.confirmPassword = '';
							this.toast.error(data[0].message)
						}
					})
		}
	}
	savepro(p, temppassword) {
		////console.log(p)
		this.showloader = true;
		this.resp = " ";
		this.temppassword =temppassword;
		if (!p.value.realtimemessage)
			p.value.realtimemessage = false
		if (!p.value.realtimealert)
			p.value.realtimealert = false
		p.value.uploadimage = this.imagearr;
		if (this.imagearr == undefined) {
			p.value.uploadimage = [];
		}
		if (!p.value.comType) {
			p.value.comType = ""
		}
		if (typeof p.value.phone != 'string' || p.value.phone instanceof Object || p.value.phone == null) {
			p.value.phone = "";
		}
		if (p.value.phoneOther == null) {
			p.value.phoneOther = "";
		}
		if (p.value.phone) {
			let telecode = p.value.code.split(',')
			p.value.teleCode = telecode[0]
			p.value.teleCountryCode = telecode[1]
		} else {
			p.value.teleCode = ''
			p.value.teleCountryCode = ''
		}
		if (p.value.phoneOther) {
			let telecode = p.value.codeOther.split(',')
			p.value.teleCodeOther = telecode[0]
			p.value.teleCountryCodeOther = telecode[1]
		} else {
			p.value.teleCodeOther = ''
			p.value.teleCountryCodeOther = ''
		}
		if (!p.value.otherPhoneType) {
			p.value.otherPhoneType = ''
		}
		if (this.Patpro.comType == 'NONE') {
			p.value.notificationfrequency = 'None'
			p.value.realtimemessage = false
			p.value.realtimealert = false
		}
		p.value.useraccountId = this.currentUser.item.userAccountId
		p.value.dob = this.datepipe.transform(this.changeFormatToDate(p.value.dob), 'yyyy-MM-dd');
		this.userService.updateccprofile(p.value)
			.subscribe(
				data => {

					this.showloader = false;
					
					if (data.updateStatus == "true") {
						if(this.prefLang !== this.userService.defaultLang) {
							setTimeout(() => {
								this.getSecurityQuestions();
								this.fetchOutOfOfficeStatus();
								this.bindCNStatus();
							}, 500);	
							this.updateCheck = this.updateCheck+1;
							this.userService.setCurrentLanguage(this.prefLang);		
						}
						else {
							this.respass = this.userService.translateText('patient_portal.display_messages.profile_updated.success');
							this.userService.logAudit("updateCCProfile", 0).subscribe(data => { })
							this.modalRef = this.modalService.show(temppassword, { class: 'modal-sm', backdrop: 'static' });
							this.movable()
							if (!this.isProfileUpdate)
								this.userService.setProfileAuth();
						}				
					} else {
						this.resp = this.userService.translateText('hospital_portal.disp_messages.profile_update.error');
					}
				}

			);
	}

	tempMail: any;
	//internally login 
	submit() {
		//this.phoneOthervalue = false
		this.modalRef.hide()
		if (this.isProfileUpdate && (this.Patpro.email != this.tempMail)) {
			this.currentUser.item.userId = this.Patpro.email
		}
		this.resetprofile();

	}
	resetprofile() {
		this.userService
			.getProfile(this.currentUser.item.userId)
			.subscribe(
				res => {
					let data = res.aaData;
					for (var i = 0; i < data.length; i++) {
						this.Patpro = data[i];
						if (this.Patpro.comType == 'NONE') {
							this.Patpro.notificationfrequency = 'None'
							this.Patpro.realtimemessage = false
							this.Patpro.realtimealert = false
						}
						if (this.Patpro.imagePath.search("default_") == -1)
							this.dataimg = this.imageURL + this.Patpro.imagePath;
						else
							this.dataimg = this.defaultUl

						this.temMail = data[i].email;
						this.temPhone = data[i].phone
						if (this.Patpro.phone) {
							this.Patpro.code = this.Patpro.teleCode + ',' + this.Patpro.teleCountryCode
						}
						else {
							if (this.currentUser.item.language != 'en_uk') {
								this.Patpro.code = '+1,USA'
							} else if (this.currentUser.item.language == 'en_uk') {
								this.Patpro.code = '+44,UK'
							}
							if (this.currentUser.item.clientTeleCode)
								this.Patpro.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
						}
						if (this.Patpro.phoneOther) {
							this.phoneOthervalue = true
							this.Patpro.codeOther = this.Patpro.teleCodeOther + ',' + this.Patpro.teleCountryCodeOther
						}
						else {
							this.phoneOthervalue = false
							if (this.currentUser.item.language != 'en_uk') {
								this.Patpro.codeOther = '+1,USA'
							} else if (this.currentUser.item.language == 'en_uk') {
								this.Patpro.codeOther = '+44,UK'
							}
							if (this.currentUser.item.clientTeleCode)
								this.Patpro.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
						}
						if (this.Patpro.comType == 'SMS') {
							this.Patpro.comType = 'TEXT'
						} else if (!this.Patpro.comType) {
							this.Patpro.comType = 'NONE'
						}
						this.Cprofile = JSON.parse(JSON.stringify(this.Patpro))
					}
				}
			);
	}
	loginAs(credentials) {
		this.userService
			.attemptProfileAuth(credentials)
			.subscribe(
				data => {
				},
				err => {

				}
			);
	}

	changepwd(da, template: TemplateRef<any>) {
		this.resepon = "";
		//////console.log(da.value);
		this.patientservice.lastpass(this.currentUser.item.userAccountId, da.value.newPassword)
			.subscribe(
				data => {
					if (data.status != 'failure') {
						this.userService.chagepassword(da.value, this.currentUser.item.userAccountId)
							.subscribe(
								data => {
									//////console.log(data);
									if (data.item.status == "failure") {
										this.resepon = data.item.message;
										// this.modalRef = this.modalService.show(template);

									} else if (data.item.status == "success") {
										this.patientservice.pwdHistroy(this.currentUser.item.userAccountId, da.value.newPassword)
											.subscribe(data => { })
										this.res = data.item.message;
										this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
										this.userService.logAudit("chagepassword", 0).subscribe(data => { })
										this.userService.populate();
										this.movable()
									} else {
										this.res = " ";

									}
								}
							);
					}
					else {
						this.resepon = data.message;
					}


				})
	}
	dateValueChange(event) {
		if (event.keyCode != 8) {
			if (event.target.value.length == 2 || event.target.value.length == 5) {
				var thisVal = event.target.value;
				thisVal += '/';
				event.target.value = thisVal;
			}
		}
	}
	onKey(event: any) {
		var lowerCaseLetters = /[a-z]/g;
		var upperCaseLetters = /[A-Z]/g;
		var numbers = /[0-9]/g;
		var special = /[#$^+=!*()@%&]/g;
		if (event.target.value.match(lowerCaseLetters)) {
			this.passval = true
		}
		else {
			this.passval = false
		}
		if (event.target.value.match(upperCaseLetters)) {
			this.passval1 = true
		}
		else {
			this.passval1 = false
		}
		if (event.target.value.match(numbers)) {
			this.passval2 = true
		}
		else {
			this.passval2 = false
		}
		if (event.target.value.length >= 8) {
			this.passval3 = true
		}
		else {
			this.passval3 = false
		}
		if (event.target.value.match(special)) {
			this.passval4 = true
		}
		else {
			this.passval4 = false
		}

	}
	onKey1(event: any) {
		var lowerCaseLetters = /[a-z]/g;
		var upperCaseLetters = /[A-Z]/g;
		var numbers = /[0-9]/g;
		var special = /[#$^+=!*()@%&]/g;
		if (event.target.value.match(lowerCaseLetters)) {
			this.passkey = true
		}
		else {
			this.passkey = false
		}
		if (event.target.value.match(upperCaseLetters)) {
			this.passkey1 = true
		}
		else {
			this.passkey1 = false
		}
		if (event.target.value.match(numbers)) {
			this.passkey2 = true
		}
		else {
			this.passkey2 = false
		}
		if (event.target.value.length >= 8) {
			this.passkey3 = true
		}
		else {
			this.passkey3 = false
		}
		if (event.target.value.match(special)) {
			this.passkey4 = true
		}
		else {
			this.passkey4 = false
		}


	}
	onKey2(event: any) {
		var lowerCaseLetters = /[a-z]/g;
		var upperCaseLetters = /[A-Z]/g;
		var numbers = /[0-9]/g;
		var special = /[#$^+=!*()@%&]/g;
		if (event.target.value.match(lowerCaseLetters)) {
			this.passlast = true
		}
		else {
			this.passlast = false
		}
		if (event.target.value.match(upperCaseLetters)) {
			this.passlast1 = true
		}
		else {
			this.passlast1 = false
		}
		if (event.target.value.match(numbers)) {
			this.passlast2 = true
		}
		else {
			this.passlast2 = false
		}
		if (event.target.value.length >= 8) {
			this.passlast3 = true
		}
		else {
			this.passlast3 = false
		}
		if (event.target.value.match(special)) {
			this.passlast4 = true
		}
		else {
			this.passlast4 = false
		}
	}

	tempphone: any;
	index: number = 0
	checkphonlength(e, event, userdetails) {
		let code = this.Patpro.code.split(',')
		let codeOther = this.Patpro.codeOther.split(',')
		if (code[0] + this.Patpro.phone == codeOther[0] + this.Patpro.phoneOther && this.Patpro.phoneOther) {
			this.toast.error(this.userService.translateText('hospital_portal.disp_messages.mob_no_should_not_same.error'), '', {
				timeOut: this.timealert
			})
			this.Patpro.phone = ''
			return
		} else {
			let telecode = e.split(',')
			let codecoun = telecode[1]
			let tempcode = this.tempCode.split(',')
			if (userdetails) {
				let temPhone = ''
				if (this.tempphone) {
					temPhone = tempcode[0] + '-' + this.tempphone
				}
				let data = {
					"oldEmail": '',
					"newEmail": '',
					"oldPhone": temPhone,
					"newPhone": telecode[0] + '-' + this.Patpro.phone,
					"addOrEdit": "edit",
					"updatingProfileRole": this.currentUser.item.userGroupId
				}
				this.patientservice.getUserExist(data, this.currentUser.item.userAccountKey).subscribe(
					data => {
						if (data.status == 'success') {
							let phone = telecode[0] + '-' + this.Patpro.phone
							this.userService.getuserdetails(phone)
								.subscribe(
									data => {
										if (data.firstName) {
											this.userinfo = data
											if (((!this.Patpro.firstName && !this.Patpro.lastName && !this.Patpro.email) || (data.firstName != this.Patpro.firstName) || (data.lastName != this.Patpro.lastName) || (data.email != this.Patpro.email))) {
												this.modalRef1 = this.modalService.show(userdetails, {
													class: 'modal-md',
													backdrop: 'static'
												})
												this.movable();
											}
										} else {
											// this.phonemask(codecoun)
										}
									})
						} else {
							this.Patpro.phone = ""
							this.toast.error(this.userService.translateText('hospital_portal.disp_messages.mob_already_exists.error'), '', {
								timeOut: this.timealert
							})
						}
					})

				this.index = this.index + 1

			} else {
				// this.phonemask(codecoun)
			}
		}
	}


	checkphonlength1(e, event) {
		if (event)
			this.Patpro.phoneOther = event
		let code = this.Patpro.code.split(',')
		let codeOther = this.Patpro.codeOther.split(',')
		if (code[0] + this.Patpro.phone == codeOther[0] + this.Patpro.phoneOther && this.Patpro.phone) {
			this.toast.error(this.userService.translateText('hospital_portal.disp_messages.mob_no_should_not_same.error'), '', {
				timeOut: this.timealert
			})
			this.Patpro.phoneOther = ''
			return
		} else {
			let telecode = e.split(',')
			let codecoun = telecode[1]
			this.checkcode1(codecoun)
		}
	}
	movable() {
		$(function () {
			let modalContent: any = $('.modal-content');
			let modalHeader = $('.modal-header');
			modalHeader.addClass('cursor-all-scroll');
			modalContent.draggable({
				handle: '.modal-header'
			});
		});
	}
	changeFormatToDate(dateString) {
		var changedFormat;
		if (this.currentUser.item.language == 'en_uk' && (typeof dateString == 'string' || dateString instanceof String)) {
			var splitDate1 = dateString.split('/');
			if (splitDate1.length > 1) {
				var day1 = splitDate1[0];
				var month1 = splitDate1[1];
				var year1 = splitDate1[2];
				changedFormat = month1 + "/" + day1 + "/" + year1;
				return new Date(changedFormat)
			} else {
				var date: any = dateString
				return new Date(date)
			}
		} else {
			return new Date(dateString)
		}
	}

	validateAnswer1: boolean = false;
	validateAnswer2: boolean = false;
	validateAnswer3: boolean = false
	validateSecurityQuestion(value, qNo: number) {
		if (qNo == 1)
			this.validateAnswer1 = this.validateContainsCharacter(value) || value.length < 4;
		if (qNo == 2)
			this.validateAnswer2 = this.validateContainsCharacter(value) || value.length < 4;
		if (qNo == 3)
			this.validateAnswer3 = this.validateContainsCharacter(value) || value.length < 4;
	}
	validateContainsCharacter(value) {
		let isContains: boolean = false;
		for (const character of ['123', 'password', 'admin', 'test', this.Patpro.firstName, this.Patpro.lastName, this.Patpro.email]) {
			if (value.toLowerCase().includes(character.toLowerCase())) {
				isContains = true;
				break;
			}
		}
		return isContains;
	}

	saveSecQuestion() {
		this.showloader = true;
		const obj = {
			secQuestionOne: this.secQuestionOne,
			secQuestionThree: this.secQuestionThree,
			secQuestionTwo: this.secQuestionTwo,
			secQusAnswerOne: this.secQusAnswerOne,
			secQusAnswerThree: this.secQusAnswerThree,
			secQusAnswerTwo: this.secQusAnswerTwo
		}

		this.userService.saveSecQuesAns(this.currentUser.item.userAccountId, obj)
			.subscribe(data => {
				this.showloader = false;
				if (data.status == "Success") {

					this.userService.logAudit("saveSecQuesAns", 0).subscribe(data => { })
					this.toast.success(this.userService.translateText('hospital_portal.disp_messages.question_saved.success'), '', {
						timeOut: this.timealert
					})
				}
				else {
					this.toast.error(this.userService.translateText('patient_portal.display_messages.invalid_data.error'), '', {
						timeOut: this.timealert
					})
				}
			})
	}

	getSecretQue() {
		this.userService.getSecQuesAns(this.currentUser.item.userAccountId)
			.subscribe(data => {
				if (data.secQuestionIdOne) {
					this.secQuestionOne = data.secQuestionIdOne
					this.secQuestionTwo = data.secQuestionIdTwo
					this.secQuestionThree = data.secQuestionIdThree
					setTimeout(() => {
						const cnDropElement = document.getElementById("select1nd") as HTMLSelectElement;
						if (cnDropElement) {
							cnDropElement.value = this.secQuestionOne;
						}

						const cnDropElement1 = document.getElementById("select2nd") as HTMLSelectElement;
						if (cnDropElement1) {
							cnDropElement1.value = this.secQuestionTwo;
						}

						const cnDropElement2 = document.getElementById("select3nd") as HTMLSelectElement;
						if (cnDropElement2) {
							cnDropElement2.value = this.secQuestionThree;
						}
					}, 500);

					this.secQusAnswerOne = data.secQusAnswerOne
					this.secQusAnswerTwo = data.secQusAnswerTwo
					this.secQusAnswerThree = data.secQusAnswerThree


					// //console.log("Edit Ques",data)
					this.changeques(this.secQuestionOne, 0);
				}
			})
	}
	changeques(eve, qus) {
		if (qus == 0) {
			this.secQuestionOne = eve;
		}
		if (qus == 1) {
			this.secQuestionOne = eve;
			this.secQusAnswerOne = '';
		} else if (qus == 2) {
			this.secQuestionTwo = eve;
			this.secQusAnswerTwo = '';
		} else if (qus == 3) {
			this.secQuestionThree = eve;
			this.secQusAnswerThree = '';
		}
		const d1 = _.reject(this.question, (o: any): any => { return o.userSecQuestionsId == this.secQuestionOne })
		this.selectques2 = _.reject(d1, (o: any): any => { return o.userSecQuestionsId == this.secQuestionTwo })
		this.selectques1 = _.reject(d1, (o: any): any => { return o.userSecQuestionsId == this.secQuestionThree })
		const ss = _.reject(this.question, (o: any): any => { return o.userSecQuestionsId == this.secQuestionThree })
		this.selectques = _.reject(ss, (o: any): any => { return o.userSecQuestionsId == this.secQuestionTwo })
	}

	focus(event, id) {
		if (event) {
			$(`#${id}`).addClass('shown')
		}

	}
	outfocus(event, id) {
		if (event) {
			$(`#${id}`).removeClass('shown')
		}

	}
	// notifyFrqeuency(event){
	// 	////console.log(event)
	// 	if(event=='None'){
	// 		this.Patpro.realtimemessage = false
	// 		this.Patpro.realtimealert = false
	// 	}
	// }

	phoneOthervalue: any = true
	viewalterno(phoneOthervalue) {
		if (!phoneOthervalue) {
			this.phoneOthervalue = true
			this.Patpro.otherPhoneType = 1
			this.changeAlterNo()
		}
	}
	changeAlterNo() {
		if (this.currentUser.item.language != 'en_uk') {
			this.Patpro.codeOther = '+1,USA'
		} else if (this.currentUser.item.language == 'en_uk') {
			this.Patpro.codeOther = '+44,UK'
		}
		if (this.currentUser.item.clientTeleCode) {
			this.Patpro.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
		}
		this.Patpro.phoneOther = ''
	}
	updatedProfile: any = ''
	yesToShowUser(status) {
		if (status) {
			this.modalRef1.hide();
			this.Patpro.dob = new Date(this.userinfo.DOB);
			if (this.userinfo.imagePath && this.userinfo.imagePath.search("default_") == -1) {
				if (this.currentUser.item) {
					if (this.currentUser.item.hostModel == "CLOUD")
						this.imageURL = environment.cloudeImageURL;
					else
						this.imageURL = environment.vmImageURL;
				}
				this.patientUrl = this.imageURL + this.userinfo.imagePath;
			}
			this.Patpro.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
			this.Patpro.codeOther = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
			if (this.userinfo.teleCode)
				this.Patpro.code = this.userinfo.teleCode + ',' + this.userinfo.teleCountryCode;
			if (this.userinfo.teleCodeOther)
				this.Patpro.codeOther = this.userinfo.teleCodeOther + ',' + this.userinfo.teleCountryCodeOther;
			this.Patpro.firstName = this.userinfo.firstName
			this.Patpro.lastName = this.userinfo.lastName
			this.Patpro.userTitle = this.userinfo.userTile
			this.Patpro.email = this.userinfo.email ? this.userinfo.email : ''
			this.Patpro.phone = this.userinfo.phone ? this.userinfo.phone : ''
			if (this.userinfo.comType == 'SMS') { this.userinfo.comType = 'TEXT' }
			this.Patpro.comType = this.userinfo.comType ? this.userinfo.comType : 'None'
			this.Patpro.notificationfrequency = this.userinfo.notificationFrequency ? this.userinfo.notificationFrequency : 'None'
			this.Patpro.realtimealert = this.userinfo.realTimeAlert ? this.userinfo.realTimeAlert : false
			this.Patpro.realtimemessage = this.userinfo.realTimeMsg ? this.userinfo.realTimeMsg : false
			this.Patpro.phoneOther = this.userinfo.phoneOther ? this.userinfo.phoneOther : ''
			this.Patpro.otherPhoneType = this.userinfo.otherPhoneType ? this.userinfo.otherPhoneType : 1
		} else {
			this.modalRef1.hide();
			this.Patpro.email = ''
			this.Patpro.phone = ''
			this.Patpro.code = this.currentUser.item.clientTeleCode + ',' + this.currentUser.item.clientCountryCode
		}
	}
	OnchangeProfile() {
		if (this.updatedProfile == 'New') {
			this.updatedProfile = 'updated'
		}
	}

	bindCNStatus() {
		this.outOfOfficeArr = [{
			id: 1,
			label: this.userService.translateText('patient_portal.my_profile.out_of_office.label')
		},{
			id: 2,
			label: this.userService.translateText('patient_portal.my_profile.return_to_work.label')
		},{
			id: 3,
			label: this.userService.translateText('hospital_portal.profile.none.label')
		}];
	}

	changeOfOffice() {
		if(!this.outOfOfficeReason) {
			this.outOfOfficeerror = true;
			return;
		} else this.outOfOfficeerror = false;
	
		let payload = {
			"userAccountId": this.currentUser.item.userAccountId,
			"outOfOfficeMasterId": 1,
			"outOfOfficeReason": this.outOfOfficeReason,
			"loginAttemptonooo": false,
				outOfOfficeFromDate: this.datepipe.transform(new Date(this.fromDate), 'yyyy-MM-dd'),
				outOfOfficeToDate: this.datepipe.transform(new Date(this.toDate), 'yyyy-MM-dd')
		
		};

		this.userService
			.RecordUserOutOfOfficeStatus(payload)
			.subscribe(res => {
				if(res && res?.SUCCESS) {
					this.toast.success(res?.SUCCESS, '', {
						timeOut: this.timealert
					});
					localStorage.setItem('returnToOffice', 'true');
			
						// this.userService.logoutuser(this.currentUser.item.userAccountId)
						// if (window.localStorage['plogin']) {
						// 	var plogin = window.localStorage['plogin']
						// 	window.localStorage.removeItem('plogin');
						// 	this.userService.purgeAuth();
						// 	this.router.navigateByUrl('/plogin/' + plogin);
						// }
						// else {
						// 	this.userService.purgeAuth();
						// 	this.router.navigateByUrl('/login');
						// }
					}
				
				
		});
	}	
}
